import { useCallback, useRef, useState } from "react";
import InventariosService from "../api/inventarios.api";

/**
 * Hook para el drawer de resultado de un inventario: abre, carga el detalle y cierra
 * @returns {{ abierto: boolean, inventario: Object|null, loading: boolean, error: string|null,
 *   abrir: (id: number) => Promise<void>, cerrar: () => void, setInventario: Function }}
 */
export const useDrawerInventario = () => {
    const [abierto, setAbierto] = useState(false);
    const [inventario, setInventario] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    // Si se abre otro inventario antes de que llegue el anterior, la respuesta vieja se descarta
    const ultimaPeticion = useRef(0);

    const abrir = useCallback(async (id) => {
        const peticion = ++ultimaPeticion.current;
        setAbierto(true);
        setInventario(null);
        setError(null);
        setLoading(true);
        try {
            const data = await InventariosService.getById(id);
            if (peticion === ultimaPeticion.current) setInventario(data);
        } catch (err) {
            if (peticion === ultimaPeticion.current) setError(err.message || "No se pudo cargar el inventario.");
        } finally {
            if (peticion === ultimaPeticion.current) setLoading(false);
        }
    }, []);

    const cerrar = useCallback(() => setAbierto(false), []);

    return { abierto, inventario, loading, error, abrir, cerrar, setInventario };
};
